import * as React from "react";
import TextSection from "./common/text_section";
import Decoration from "./common/decoration";
import images from "./common/assets/images";

const RentOutSection: React.FC = () => {
  return (
    <div className="h-[279px] relative overflow-hidden bg-primary flex flex-col md:flex-row items-center justify-center p-6 md:p-12">
      <img
        src={images.decoration}
        alt=""
        className="absolute -left-[450px] -top-[80px]"
      />
      <div className="hidden md:flex md:flex-[0.4] relative h-full justify-center">
        <Decoration />
      </div>

      <div className="md:flex-[0.6] text-center md:text-left">
        <TextSection />
      </div>
    </div>
  );
};

export default RentOutSection;
